export const environment = {
  production: false,
  appConfig: {
    adminGatewayServiceBaseUrl: 'https://admin-gateway.skfh.dev',
    //adminGatewayServiceBaseUrl:"http://localhost:5028",
  },
  appCDNConfig: {
    CDN: 'https://mr-oss-dev-01.oss-me-central-1.aliyuncs.com/',
  },
  firebase: {},
  mapKey: 'AIzaSyDt-3iS_kTNAHFiFi32b2dSRU8NzlaWR8g',
  sentry: {
    dsn: 'https://b287fd1bfa52a057ab67098822143fd6@o4510658276163584.ingest.de.sentry.io/4511971108585552',
    name: 'development',
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    enabled: true,
  },
};
